/**
 * Track Order - iThink Logistics order tracking API
 * Uses same pattern as delivery-services.js: fetch API, display response
 */
(function () {
  function initTrackOrder() {
    document.querySelectorAll('.track-order-form').forEach(function (section) {
      const form = section.querySelector('[data-tof-form]');
      const orderInput = section.querySelector('[data-tof-order]');
      const submitBtn = section.querySelector('[data-tof-submit]');
      const errorEl = section.querySelector('[data-tof-error]');
      const resultEl = section.querySelector('[data-tof-result]');
      const configEl = section.querySelector('[data-tof-config]');

      if (!form || !orderInput || !submitBtn || !configEl) return;

      var config;
      try {
        config = JSON.parse(configEl.textContent);
      } catch (e) {
        console.warn('Track Order: Invalid config', e);
        return;
      }

      var apiUrl = config.apiUrl;
      var accessToken = config.accessToken;
      var secretKey = config.secretKey;
      var useIthink = apiUrl && accessToken && secretKey;

      function hideError() {
        if (errorEl) {
          errorEl.textContent = '';
          errorEl.style.display = 'none';
        }
      }

      function showError(msg) {
        if (errorEl) {
          errorEl.textContent = msg;
          errorEl.style.display = 'block';
        }
      }

      function hideResult() {
        if (resultEl) {
          resultEl.classList.remove('tof__result--visible');
          resultEl.innerHTML = '';
        }
      }

      function showResult(html) {
        if (resultEl) {
          resultEl.innerHTML = html;
          resultEl.classList.add('tof__result--visible');
        }
      }

      function formatDateTime(str) {
        if (!str) return '-';
        return str;
      }

      function renderTrackingResult(trackData) {
        var awb = trackData.awb_no || '-';
        var logistic = trackData.logistic || '-';
        var currentStatus = trackData.current_status || '-';
        var expectedDate = trackData.expected_delivery_date || trackData.promise_delivery_date || '-';
        var cancelStatus = trackData.cancel_status || '';
        var orderType = (trackData.order_details && trackData.order_details.order_type) || '-';
        var orderNumber = (trackData.order_details && trackData.order_details.order_number) || '-';

        var lastScan = trackData.last_scan_details;
        var lastScanHtml = '';
        if (lastScan) {
          lastScanHtml = '<div class="tof__result-row">' +
            '<span class="tof__result-label">Last update:</span> ' +
            '<span class="tof__result-value">' + formatDateTime(lastScan.status_date_time) + ' - ' + (lastScan.scan_location || '') + '</span>' +
            '</div>' +
            (lastScan.remark ? '<div class="tof__result-row"><span class="tof__result-value">' + lastScan.remark + '</span></div>' : '');
        }

        var scanList = trackData.scan_details;
        var scanHtml = '';
        if (scanList && Array.isArray(scanList) && scanList.length > 0) {
          scanHtml = '<div class="tof__scan-list"><div class="tof__result-title">Tracking History</div>';
          scanList.forEach(function (s) {
            scanHtml += '<div class="tof__scan-item">' +
              '<div class="tof__result-row"><span class="tof__result-label">' + (s.status || '-') + '</span></div>' +
              '<div class="tof__scan-date">' + formatDateTime(s.scan_date_time) + (s.scan_location ? ' - ' + s.scan_location : '') + '</div>' +
              (s.remark ? '<div class="tof__result-value">' + s.remark + '</div>' : '') +
              '</div>';
          });
          scanHtml += '</div>';
        }

        var customer = trackData.customer_details;
        var customerHtml = '';
        if (customer) {
          customerHtml = '<div class="tof__scan-list"><div class="tof__result-title">Delivery Address</div>' +
            '<div class="tof__result-row"><span class="tof__result-value">' + (customer.customer_name || '') + '</span></div>' +
            '<div class="tof__result-row"><span class="tof__result-value">' + [customer.customer_address1, customer.customer_address2, customer.customer_address3].filter(Boolean).join(', ') + '</span></div>' +
            '<div class="tof__result-row"><span class="tof__result-value">' + (customer.customer_city || '') + ', ' + (customer.customer_state || '') + ' - ' + (customer.customer_pincode || '') + '</span></div>' +
            (customer.customer_mobile ? '<div class="tof__result-row"><span class="tof__result-value">' + customer.customer_mobile + '</span></div>' : '') +
            '</div>';
        }

        return '<div class="tof__result-status">' + currentStatus + '</div>' +
          '<div class="tof__result-row"><span class="tof__result-label">AWB No:</span> <span class="tof__result-value">' + awb + '</span></div>' +
          '<div class="tof__result-row"><span class="tof__result-label">Courier:</span> <span class="tof__result-value">' + logistic + '</span></div>' +
          '<div class="tof__result-row"><span class="tof__result-label">Expected delivery:</span> <span class="tof__result-value">' + expectedDate + '</span></div>' +
          (cancelStatus ? '<div class="tof__result-row"><span class="tof__result-label">Cancel status:</span> <span class="tof__result-value">' + cancelStatus + '</span></div>' : '') +
          '<div class="tof__result-row"><span class="tof__result-label">Order no:</span> <span class="tof__result-value">' + orderNumber + '</span></div>' +
          '<div class="tof__result-row"><span class="tof__result-label">Order type:</span> <span class="tof__result-value">' + orderType + '</span></div>' +
          lastScanHtml +
          scanHtml +
          customerHtml;
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var awb = (orderInput.value || '').trim();
        if (!awb) {
          showError('Please enter your order or tracking number.');
          return;
        }

        hideError();
        hideResult();

        if (!useIthink) {
          showError('Order tracking is not configured. Add iThink API credentials (API URL, Access token, Secret key) in section settings.');
          return;
        }

        var btnText = submitBtn.querySelector('.tof__button-text');
        var origText = btnText ? btnText.textContent : 'Track Order';
        if (btnText) btnText.textContent = 'Tracking...';
        submitBtn.disabled = true;

        var payload = {
          data: {
            awb_number_list: awb,
            access_token: accessToken,
            secret_key: secretKey
          }
        };

        fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.status_code === 200 && data.data && typeof data.data === 'object') {
              var awbKey = Object.keys(data.data)[0];
              var trackData = awbKey ? data.data[awbKey] : null;
              if (trackData && trackData.message === 'success') {
                showResult(renderTrackingResult(trackData));
              } else {
                showError(trackData && trackData.message ? trackData.message : 'No tracking information found for this number.');
              }
            } else {
              showError(data.message || data.error || 'Could not fetch tracking details. Please try again.');
            }
          })
          .catch(function (err) {
            var msg = 'Could not connect to tracking service. Please try again.';
            if (err.message && err.message.indexOf('Failed to fetch') !== -1) {
              msg = 'Could not connect. If you see a CORS error, the API may need to be accessed via a proxy.';
            }
            showError(msg);
          })
          .finally(function () {
            submitBtn.disabled = false;
            if (btnText) btnText.textContent = origText;
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTrackOrder);
  } else {
    initTrackOrder();
  }
  document.addEventListener('shopify:section:load', initTrackOrder);
})();
